// MIDAS V3 — History skeleton (Phase 5)
//
// 8 placeholder rows that match the MidasHistoryRowV3 anatomy:
//   • 56px time col (two stacked mono blocks)
//   • flex-1 title + preview
//   • Tag pill placeholder
//   • Arrow placeholder
//
// Shimmer is a token-aware pulse animation. Reduced-motion users get a
// static block thanks to the global override in midas-v3-tokens.scss.
//
// No MUI, no @emotion, no `sx`, no `dt` tokens.
import React from "react";

const PULSE: React.CSSProperties = {
  background: "var(--midas-v3-card-2)",
  animation: "midas-pulse 1.6s ease-in-out infinite",
  borderRadius: 4,
};

const RowSkeleton: React.FC = () => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: 14,
      padding: "14px 18px",
      borderBottom: "1px solid var(--midas-v3-border-soft)",
      width: "100%",
    }}
    aria-hidden="true"
  >
    {/* Time col */}
    <div
      style={{
        width: 56,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: 6,
        paddingTop: 2,
      }}
    >
      <div style={{ ...PULSE, height: 10, width: 36 }} />
      <div style={{ ...PULSE, height: 8, width: 28 }} />
    </div>
    {/* Title + preview */}
    <div
      style={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      <div style={{ ...PULSE, height: 12, width: "55%" }} />
      <div style={{ ...PULSE, height: 10, width: "80%", opacity: 0.7 }} />
    </div>
    {/* Tag placeholder */}
    <div
      style={{
        ...PULSE,
        height: 22,
        width: 110,
        borderRadius: 999,
        flexShrink: 0,
        marginTop: 2,
      }}
    />
    {/* Arrow placeholder */}
    <div
      style={{
        ...PULSE,
        height: 10,
        width: 12,
        flexShrink: 0,
        marginTop: 6,
        opacity: 0.5,
      }}
    />
  </div>
);

const MidasHistorySkeletonV3: React.FC = () => (
  <div
    role="status"
    aria-label="Loading conversations"
    style={{
      display: "flex",
      flexDirection: "column",
    }}
  >
    {/* Eyebrow placeholder */}
    <div
      style={{
        ...PULSE,
        height: 10,
        width: 84,
        margin: "8px 18px 14px",
      }}
      aria-hidden="true"
    />
    {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
      <RowSkeleton key={i} />
    ))}
  </div>
);

export default MidasHistorySkeletonV3;
